import React from 'react';

function InstagramIcon() {
	return (
		<svg
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<circle cx='16' cy='16' r='16' fill='#F8F5EF' />
			<g clipPath='url(#clip1)'>
				<path
					d='M16.0032 11.0703C13.2808 11.0703 11.0768 13.2767 11.0768 15.9967C11.0768 18.7191 13.2832 20.9231 16.0032 20.9231C18.7256 20.9231 20.9296 18.7167 20.9296 15.9967C20.9296 13.2743 18.7232 11.0703 16.0032 11.0703ZM16.0032 19.1943C14.236 19.1943 12.8056 17.7631 12.8056 15.9967C12.8056 14.2303 14.2368 12.7991 16.0032 12.7991C17.7696 12.7991 19.2008 14.2303 19.2008 15.9967C19.2016 17.7631 17.7704 19.1943 16.0032 19.1943Z'
					fill='#CF004F'
				/>
				<path
					d='M19.9585 6.46046C18.1921 6.37806 13.8169 6.38206 12.0489 6.46046C10.4953 6.53326 9.12488 6.90846 8.02008 8.01326C6.17368 9.85966 6.40968 12.3477 6.40968 15.9965C6.40968 19.7309 6.20168 22.1613 8.02008 23.9797C9.87368 25.8325 12.3977 25.5901 16.0033 25.5901C19.7025 25.5901 20.9793 25.5925 22.2873 25.0861C24.0657 24.3957 25.4081 22.8061 25.5393 19.9509C25.6225 18.1837 25.6177 13.8093 25.5393 12.0413C25.3809 8.67086 23.5721 6.62686 19.9585 6.46046ZM22.7545 22.7581C21.5441 23.9685 19.8649 23.8605 15.9801 23.8605C11.9801 23.8605 10.3761 23.9197 9.20568 22.7461C7.85768 21.4045 8.10168 19.2501 8.10168 15.9837C8.10168 11.5637 7.64808 8.38046 12.0841 8.15326C13.1033 8.11726 13.4033 8.10526 15.9689 8.10526L16.0049 8.12926C20.2681 8.12926 23.6129 7.68286 23.8137 12.1181C23.8593 13.1301 23.8697 13.4341 23.8697 15.9957C23.8689 19.9493 23.9441 21.5629 22.7545 22.7581Z'
					fill='#CF004F'
				/>
				<path
					d='M21.1248 12.027C21.7606 12.027 22.276 11.5116 22.276 10.8758C22.276 10.24 21.7606 9.72461 21.1248 9.72461C20.489 9.72461 19.9736 10.24 19.9736 10.8758C19.9736 11.5116 20.489 12.027 21.1248 12.027Z'
					fill='#CF004F'
				/>
			</g>
			<defs>
				<clipPath id='clip1'>
					<rect
						width='19.2'
						height='19.2'
						fill='white'
						transform='translate(6.40002 6.3999)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default InstagramIcon;
